export var animTransition = {
    duration: 0.2,
    ease: [0.04, 0.62, 0.23, 0.98]
};
